import React, { Component } from 'react';
import catLoad from '../../assets/catLoad.gif';

class CatLoading extends Component {

    state = { 
        loading: true,
        onError: false,
     }

    img = this.props.Img;

    handleLoad = e => {
        this.setState({loading: false});
    }

    handleError = e => {
        this.setState({loading: false});
        this.setState({onError: true});
    }
    
    render() {
        return (
            <>
                {this.state.loading && <img src={catLoad}></img>}
                <img 
                    style={this.state.onError ? {display: 'none'} : {}}
                    src={this.img} 
                    onLoad={this.handleLoad} 
                    onError={this.handleError} 
                    ></img>
                {this.state.onError && <img src={catLoad}></img>}
            </>
        );
    }
}

export default CatLoading;